import React from 'react';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  GuidedHouseholdReviewIntroLayout,
} from 'Views/Page/Content/Templates/guidedHouseholdReviewIntroPageTemplate/layout';

export const PM2JourneyIntroOverviewPageLayout = () => {
  return (
    <FDStack direction="column" spacing={4} paddingY={4}>
      <FDStack direction="column" spacing={4}>
        <MetaControlField attr="stepper" />
        <MetaControlField attr="title" />
        <MetaControlField attr="description" />
      </FDStack>
      <GuidedHouseholdReviewIntroLayout />
    </FDStack>
  );
};
